module.exports = __webpack_public_path__ + "img/carpentry.0ada7337.jpg";